// 事件总线（mitt库）

import type { CollectLabel } from '@/api/common.api'
import type { MyRecordData } from '@/views/common/TopicPage/api/index.api'
import mitt, { type Emitter } from 'mitt'
import type { WordScore } from './tool'

type Events = {
  /**单词释义弹框 */
  word: {
    wordStr: string
    termName: string
    sectionResult?: WordScore
    /**题目id（收藏单词时关联题目，存入 qid） */
    qid?: number
  }
  /**提交做题 */
  submit: {
    questionId: number | string
    questionsTypeCode: string
    step?: number
    content?: string
    shareId?: number | string
    wfd?: any
  }
  /**收藏夹弹框 */
  'collect-popup': cllectData
  'expspeaking-score': MyRecordData
  'asq-score': AsqScore
  /** 练习录音上传成功，就地更新练习记录列表中对应记录的音频地址 */
  'audio-uploaded': {
    /** 评测记录 id（addXunfei 返回的 id，对应列表项 webId） */
    id: number | string
    audioPath: string
  }
  'expwriting-score': number
  // 收藏事件
  collect: {
    id: number
    color: number
    /** 来源标记：'v2-list' 表示来自 V2 收藏列表自身的取消操作（V2 列表已自行刷新，订阅的列表无需重复刷新） */
    from?: string
  }
  //练习设置弹窗
  'practiceSetting-popup': string
  // 模考保存
  mockSave: any
  // 模考停止
  mockStop: any
  // 停止计时
  stopMockTime: any
  // 恢复计时
  resumeMockTime: any
  openTargetSetGuide: any
  'ra-ktv-open': {
    audioPath: string
    postId?: number
  }
  'ra-ktv-state': {
    isKtvMode: boolean
    postId?: number
  }
  'ra-ktv-trigger': {
    postId?: number
  }
  'ra-ktv-exit': {
    postId?: number
  }
  'ra-demo-audio-play': {
    postId?: number
  }
  'ra-ktv-availability': {
    hasKtv: boolean
    postId?: number
  }
  'ra-translate-change': {
    visible: boolean
    postId?: number
  }
  'open-passed-dialog': undefined
  // 待办列表变更，通知其他共用待办组件的模块刷新
  'todo-list-updated': { scrollToTop?: boolean; fromPopup?: boolean } | undefined
  // 打开九周年活动弹窗（日历蛋糕 / 日历弹窗周年卡片等入口）
  'open-anniversary-dialog': undefined
  // 九周年弹窗「落定」：无需自动弹窗或弹窗关闭时触发，首页据此错峰放行广告弹窗
  'anniversary-settled': undefined
  // 单词释义弹窗中取消收藏（弹窗关闭时触发），通知生词收藏列表刷新
  'word-collect-cancel': { word: string }
  // 导航栏 hover 弹窗内点击跳转后，立即强制关闭弹窗
  'close-nav-popover': undefined
  // 全局打开题库综合指南弹窗（如高频库弹窗「综合命中」单元格），termId 指定选中题型
  'open-question-guide': { termId?: number | string }
}
export interface cllectData {
  label: CollectLabel
  /**机经id（v2 兼容字段）；单词收藏时为来源机经 wpId */
  qid?: number
  /**v2 wpId 字段；机经收藏时为练习详情返回的 datas[].id */
  wpId?: number
  word?: string
  termName?: string
  succeed?: (color: 1 | 2 | 3 | 4) => void
  /**
   * 已收藏内容的「修改」入口（如高频库提示条修改）：
   * 弹窗保存先取消当前收藏、再以选中收藏夹重新收藏；
   * 不传默认走单次 v2/toggle（未收藏首次收藏）——toggle 对已收藏内容是取消收藏
   */
  updateOnly?: boolean
}

export interface AsqScore {
  overall: number
  fluency: number
  pronunciation: number
  integrity: number
  audioUrl: string
  id: number | string
  postId: number
  xfWords?: string
  words?: string
}
const emitter: Emitter<Events> = mitt()
export default emitter
